export default "__VITE_ASSET__18a2f8be__"